import React, { useEffect, useRef, useState } from "react";
import { ConfigProvider } from "antd";
import { lightTheme } from "./theme";
import NavigationManager from "./NavigationManager";
import { Helmet } from "react-helmet";
import { useChatUserStore, useUserSelfStore } from "./store/apis/useUserStore";
import { SocketProvider } from "./Context/SocketContext";
import Loader from "./Components/Loader";
import { getSharedSso, isLogoutPending } from "./utils/ssoCookie";
// import { VideoCallProvider } from "./modules/VideoChat/VideoCallProvider";

const App = () => {
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const [isTabAlreadyOpen, setIsTabAlreadyOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const title = userData?.companyName || "Econnect";
  const faviconPath = userData?.companyFavIcoUrl;

  const faviconUrl = faviconPath
    ? faviconPath.startsWith("/public")
      ? `${faviconPath}`
      : faviconPath
    : `${process.env.PUBLIC_URL}/favicon-Defualt.png`; // fallback from public folder

    useEffect(() => {
      const tabId = Math.random().toString(36).substring(7);
      const channel = new BroadcastChannel("tab_guard");
      const openedAt = Date.now();
  
      const handleMessage = (event) => {
        if (event.data.type === "PING") {
          channel.postMessage({
            type: "PONG",
            tabId,
            openedAt,
          });
          setIsTabAlreadyOpen(false);
          setIsLoading(false);
        }
  
        if (event.data.type === "PONG" && event.data.openedAt < openedAt) {
          // window.close();
          setIsTabAlreadyOpen(true);
          setIsLoading(false);
        }
      };
  
      channel.addEventListener("message", handleMessage);
  
      channel.postMessage({
        type: "PING",
        tabId,
      });
  
      // Fallback timeout in case no response is received
      const timeoutId = setTimeout(() => {
        setIsLoading(false);
      }, 2000);
  
      return () => {
        clearTimeout(timeoutId);
        channel.removeEventListener("message", handleMessage);
        channel.close();
      };
    }, []);

    // Cross-product single logout: if this tab has a session but the shared
    // `wm_shared_token` cookie has vanished (a sibling app logged out), drop the
    // local session too. Token expiry leaves the cookie in place, so this only
    // fires on a real sibling logout.
    useEffect(() => {
      const checkSharedCookie = () => {
        if (document.visibilityState && document.visibilityState !== "visible") {
          return;
        }
        const hasSession = !!localStorage.getItem("authToken");
        if (hasSession && !getSharedSso() && !isLogoutPending()) {
          localStorage.clear();
          window.location.href = "/";
        }
      };
      document.addEventListener("visibilitychange", checkSharedCookie);
      window.addEventListener("focus", checkSharedCookie);
      return () => {
        document.removeEventListener("visibilitychange", checkSharedCookie);
        window.removeEventListener("focus", checkSharedCookie);
      };
    }, []);

    if (isLoading) {
      return <Loader />;
    }

    if (isTabAlreadyOpen) {
      return (
        <div className="duplicate-wrapper">
          <div className="duplicate">
            <h1>
              { " " }
              <i class="fa-solid fa-triangle-exclamation"></i> Duplicate Tab
              Detected
            </h1>
            <p>This application is already running in another tab.</p>
            <p>
              Please return to the original tab or close that tab and refresh this
              page.
            </p>
          </div>
        </div>
      );
    }

  
  return (
    <>
      <Helmet>
        <title>{title}</title>
        <link rel="icon" type="image/png" href={faviconUrl} />
      </Helmet>
      <SocketProvider user={userData}>
        {/* <VideoCallProvider userId={userData?._id} socket={socket}> */}
      <ConfigProvider theme={lightTheme}>
        <NavigationManager />
      </ConfigProvider>
        {/* </VideoCallProvider> */}
    </SocketProvider>
    </>
  );
};

export default App;
